import { useTranslation } from "react-i18next";
import { LoadingState } from "shared/components/empty/LoadingState";
import PageBody from "shared/components/layout/PageBody";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs } from "shared/components/layout/PageTabs";
import { AppConfig } from "shared/config/AppConfig";
import { useEffectOnce } from "shared/hooks/useEffectOnce";

export const AccountLayout: React.FC = () => {
  const { t } = useTranslation(["account"]);

  useEffectOnce(() => {
    if (AppConfig.subdomains?.isSubdomain) {
      const redirectUrl = new URL(
        location.pathname,
        AppConfig.subdomains.authRootUrl.toString(),
      );
      window.location.replace(redirectUrl);
    }
  });

  if (AppConfig.subdomains?.isSubdomain) {
    return (
      <PageContainer>
        <PageContent isFullHeight={true}>
          <PageBody>
            <LoadingState />
          </PageBody>
        </PageContent>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageContent isFullHeight={true}>
        <PageHeader title={t("account:title")} size="lg" />
        <PageBody>
          <PageTabs />
        </PageBody>
      </PageContent>
    </PageContainer>
  );
};
